import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    salaryPeriods: [],
    salaryPeriodsCount: 0,
    salaryPeriod: {},
    salaryPeriodSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getSalaryPeriods(state) {
      return state.salaryPeriods
    },
    getSalaryPeriodsCount(state) {
      return state.salaryPeriodsCount
    },
    getSalaryPeriod(state) {
      return state.salaryPeriod
    },
    getSalaryPeriodSaveStatus(state) {
      return state.salaryPeriodSave
    },
  },
  mutations: {
    SALARY_PERIODS_LIST(state, data) {
      state.salaryPeriods = data
    },
    SALARY_PERIOD_VIEW(state, data) {
      state.salaryPeriod = data
    },
    SALARY_PERIODS_COUNT(state, data) {
      state.salaryPeriodsCount = data
    },
    SALARY_PERIOD_SAVE(state, data) {
      state.salaryPeriodSave = data
    },
  },
  actions: {
    salaryPeriodsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/salary_periods', data)
        .then(response => {
          commit('SALARY_PERIODS_LIST', response.data.data)
          commit('SALARY_PERIODS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    salaryPeriodView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'salary_periods.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/salary_periods', data)
        .then(response => {
          commit('SALARY_PERIOD_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    salaryPeriodSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/salary_periods/saveData', data)
        .then(response => {
          commit('SALARY_PERIOD_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
